import { useContext } from 'react';
import PropTypes from 'prop-types';

import Link from '../Link';
import RichText, { fragment } from '../RichText';
import IndividualBlade from '../../Custom/IndividualBlades';
import LegalDetails from '../../Custom/LegalDetails';
import CtaModal from '../../Custom/CtaModal';
import ApplicationMenu from '../../Custom/ApplicationMenu';
import { ResponsiveContext } from '../../Providers/Responsive';

import SocialMediaCta from './SocialMediaCta';
import { CtaWrapper, StyledButton, StyledImage } from './styles';

const Ctas = ({
  ctas,
  className = '',
  position = '',
  alignment = '',
  direction = 'column',
}) => {
  if (!ctas) return null;

  const { mobile } = useContext(ResponsiveContext);

  const toggleAdaChatBot = () => {
    if (!window || !window.adaEmbed) return false;
    return window.adaEmbed.toggle();
  };

  // don't render link if mobile and hideMobile option selected
  const ctaMobileResolve = cta => {
    if (!mobile && cta.mobile) {
      return null;
    }
    return (
      <Link key={`cta-${cta.id}`} data={cta}>
        <RichText document={cta.label} options={fragment} />
      </Link>
    );
  };

  const ctaResolver = cta => {
    if (cta.hideFrench === true) return null;
    if (cta.type === 'ada-chatbot') {
      return (
        <StyledButton
          key={`ada-${cta.id}`}
          type="button"
          onClick={() => toggleAdaChatBot()}
        >
          <RichText document={cta.label} options={fragment} />
        </StyledButton>
      );
    } else if (cta.type === 'social-media') {
      return <SocialMediaCta key={`social-media-${cta.id}`} data={cta} />;
    } else if (
      cta.internal &&
      cta.internal.type === 'ContentfulBlade' &&
      cta.component === 'legal-details'
    ) {
      return <LegalDetails key={`legal-details-${cta.id}`} data={cta} />;
    } else if (
      cta.internal &&
      cta.internal.type === 'ContentfulBlade' &&
      cta.component === 'application-blade'
    ) {
      return <IndividualBlade key={`app-blade-${cta.id}`} data={cta} />;
    } else if (
      cta.internal &&
      cta.internal.type === 'ContentfulBlade' &&
      cta.component === 'application-menu-blade'
    ) {
      return <ApplicationMenu key={`app-menu-${cta.id}`} data={cta} />;
    } else if (cta.internal && cta.internal.type === 'ContentfulModal') {
      return <CtaModal key={`cta-modal-${cta.id}`} data={cta} />;
    } else if (cta.internal && cta.internal.type === 'ContentfulIconWithText') {
      return (
        <Link className="unstyled-link" key={`icon-text-${cta.id}`} data={cta}>
          {cta.iconDam && (
            <StyledImage src={cta.iconDam} alt={cta.iconDam.altText || ''} />
          )}
          {cta.text && <RichText document={cta.text} />}
        </Link>
      );
    }
    return <>{ctaMobileResolve(cta)}</>;
  };

  return (
    <CtaWrapper
      className={`${className} ${alignment} ${position}`}
      direction={direction}
    >
      {ctas &&
        ctas.map(cta => {
          return ctaResolver(cta);
        })}
    </CtaWrapper>
  );
};

Ctas.propTypes = {
  ctas: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  className: PropTypes.string,
  position: PropTypes.string,
  alignment: PropTypes.string,
  direction: PropTypes.string,
};

export default Ctas;
